import React, { FC, useContext, useEffect, useState } from 'react';
import { Decision } from '../../../entity/entity.types';
import { fetchLawFirmTopDecisions } from '../lawFirm.api';
import { EntityTopDecisions } from '../../../entity/decisions/EntityTopDecisions';
import { LawFirmContext } from '../LawFirmContext';
import { PageNavContext } from '../../../components/page-nav/PageNavContext';

export const LawFirmTopDecisions: FC = () => {
  const id = 'law-firm-top-decisions';
  const {
    lawFirmInfos: { lawOfficeIdGroup, name },
    allDecisionsLink,
    experience: { decisionCount },
  } = useContext(LawFirmContext);
  const { createNav } = useContext(PageNavContext);
  const [decisions, setDecisions] = useState<Decision[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const decisionsFetched = await fetchLawFirmTopDecisions(lawOfficeIdGroup);
      setDecisions(decisionsFetched);
      if (decisionsFetched.length) {
        createNav(id);
      }
    };

    fetchData();
  }, [lawOfficeIdGroup]);

  if (!decisions.length) {
    return null;
  }

  return (
    <div id={id}>
      <EntityTopDecisions
        decisions={decisions}
        entityType="lawFirm"
        sources={{
          allDecisionsLink: 'read_all_law_firm_decisions_from_top_decisions',
          decisionLink: 'lawFirm_top_decision',
        }}
        allDecisionLink={allDecisionsLink}
        decisionCount={decisionCount}
        entityName={name}
      />
    </div>
  );
};
